function connectKit(kit) {
  if(kit.dataset.galleryReady) return;
  kit.dataset.galleryReady = 'true';
  const photos = JSON.parse(kit.querySelector('[data-kit-media]').textContent);
  let lastVariant;
  const update = () => {
    const id = kit.querySelector('[name="id"]').value;
    if(id === lastVariant) return; lastVariant = id;
    const photo = photos.find(item => String(item.id) === id);
    if(!photo) return;
    const img = kit.querySelector('.av-kit-front');
    if(img) {
      img.src = photo.src;
      img.srcset = [390, 700, 1000, 1400].map(width => {
        const url = new URL(photo.src, location.origin);
        url.searchParams.set('width', width);
        return `${url.href} ${width}w`;
      }).join(', ');
      img.alt = photo.title === 'Default Title' ? kit.querySelector('h1').textContent.trim() : photo.title;
    }
    const thumb = kit.querySelector('.av-kit-front-thumb');
    if(thumb) {thumb.src = photo.small; thumb.removeAttribute('srcset'); thumb.alt = img?.alt || '';}
    kit.querySelector('[data-kit-caption]').textContent = photo.title === 'Default Title' ? '' : photo.title;
    kit.querySelector('[data-media]')?.click();
  };
  kit.addEventListener('change', e => {if(e.target.name === 'id') update();});
  update();
}
document.querySelectorAll('.av-kit').forEach(connectKit);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.av-kit').forEach(connectKit));

